
import { catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ServiceBase } from '@app/services/base.service';
import { HttpClient } from '@angular/common/http';
import { CriacaoContaCliente } from '@app/models/criacao-conta-cliente.model';
import { Funcionario } from '@app/models/funcionario';
import { RedefinirSenhaModel } from '@app/pages/home/redefinir-senha/redefinir-senha.model';
import { ca } from 'date-fns/locale';
import { AutenticacaoDoisFatoresComponent } from '@app/pages/home/autenticacao-dois-fatores/autenticacao-dois-fatores.component';
import {  Observable, throwError } from 'rxjs';

@Injectable()
export class LoginService extends ServiceBase {

  constructor(private http: HttpClient) {
    super();
  }

  login(login: string, senha: string): Observable<Funcionario> {
    let response = this.http

      .post(this.URL_API + 'login/tokenAuth', { login, senha }).pipe(
        map(dados => response = dados),
        catchError((super.serviceError)));

    return response;
  }

  recuperarSenha(email: string): Observable<any> {
    let response = this.http
      .post(this.URL_API + 'login/recuperarSenha', JSON.stringify(email)).pipe(
        map(dados => response = dados),
        catchError((super.serviceError)));
    return response;
  }

  redefinirSenha(redefinicao: RedefinirSenhaModel): Observable<any> {
    let response = this.http
      .post(this.URL_API + 'login/redefinirSenha', redefinicao).pipe(
        map(dados => response = dados),
        catchError((super.serviceError)));
    return response;
  }

  confirmarAutenticacao(login: string, senha: string): Observable<{ Autenticacao2Fatores: boolean }> {
    const body = { login, senha };
      let response = this.http
      .post<{ Autenticacao2Fatores: boolean }>(this.URL_API + 'login/confirmarautenticacao', body).pipe(
        map(dados => dados),
        catchError((error) => this.serviceError(error)));
    return response;
  }

  autenticacaoDoisFatores(login: string, senha: string): Observable<{ Autenticacao2Fatores: boolean }> {
    const body = { login, senha };
    let response = this.http
      .post<{ Autenticacao2Fatores: boolean }>(this.URL_API + 'login/autenticacaodoisfatores', body)
       .pipe(map(dados => dados),
         catchError((super.serviceError)));
    return response;
  }

  verificarCodigo(codigo: string, login: string, senha: string): Observable<any> {
    const body = { login, senha, codigo };
    let response = this.http
      .post(this.URL_API + 'login/verificarcodigo', body)
        .pipe(map(dados => dados),
          catchError((error: any) => throwError(error)));
    return response;
  }

  //REFATORAR URGENTEMENTE!!!! MAIO/23
  teste(): Observable<any> {
    let response = this.http.get(this.URL_API +'admin/conta/novaconta').pipe(
      map(dados => response = dados),
      catchError((super.serviceError)));
    return response;
  }

  cadastrarCliente(contaCliente: CriacaoContaCliente): Observable<any> {
    let response = this.http.post(this.URL_API +'admin/conta/novaconta', contaCliente).pipe(
      map(dados => response = dados),
      catchError((super.serviceError)));
    return response;
  }

  obterClientes(): Observable<any> {
    let response = this.http.get(this.URL_API +'admin/conta/lista-clientes').pipe(
      map(dados => response = dados),
      catchError((super.serviceError)));
    return response;
  }

  excluirCliente(idCliente: number): Observable<any> {
    let response = this.http.delete(this.URL_API + `admin/conta/excluirconta/${idCliente}`).pipe(
      map(dados => response = dados),
      catchError((super.serviceError)));
    return response;
  }
}
function observableThrowError(error: any): any {
  throw new Error('Function not implemented.');
}

